// pages/MetreEntrada.jsx
import React, { useState, useEffect, useRef } from 'react';
import {
  Card,
  Typography,
  Input,
  Button,
  Space,
  message,
  Statistic,
  Row,
  Col,
  Tag,
  Alert,
  Spin,
  ConfigProvider,
  Progress,
  Select,
  DatePicker,
  Divider,Modal
} from 'antd';
import {
  CheckCircleOutlined,CloseCircleOutlined,
  TeamOutlined,
  CoffeeOutlined,
  ReloadOutlined,
  SearchOutlined,
  ClockCircleOutlined,
  LoginOutlined,
  CloseOutlined,
  CalendarOutlined,
  DownOutlined,
  UpOutlined
} from '@ant-design/icons';
import dayjs from 'dayjs';
import axios from 'axios';
import { BASE_URL } from '../utils/constants';


const { Title, Text } = Typography;

const MetreEntrada = () => {
  // Estados
  const [loading, setLoading] = useState(false);
  const [loadingCheckin, setLoadingCheckin] = useState(false);
  const [habitacionInput, setHabitacionInput] = useState('');
  const [resultado, setResultado] = useState(null);
  const [habitacionActual, setHabitacionActual] = useState('');
  const [filtrosExpandidos, setFiltrosExpandidos] = useState(false);
  const [stats, setStats] = useState({
    total: 0,
    checkedIn: 0,
    pending: 0,
    habitaciones: 0
  });
  
  // Estados para fecha y servicio (editables)
  const [selectedDate, setSelectedDate] = useState(dayjs());
  const [selectedService, setSelectedService] = useState('');
  
  // Referencia al input
  const inputRef = useRef(null);
  
  // Detectar si es Android
  const [isAndroid, setIsAndroid] = useState(false);

  // Detectar plataforma
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      setIsAndroid(true);
    }
  }, []);

  // Determinar servicio según hora actual
  const getServicioByHora = () => {
    const hora = dayjs().hour();
    const minuto = dayjs().minute();
    const tiempo = hora + minuto / 60;
    
    if (tiempo >= 1 && tiempo < 12) return 'Desayuno';
    if (tiempo >= 12 && tiempo < 17) return 'Almuerzo';
    if (tiempo >= 18 && tiempo < 24) return 'Cena';
    return 'Desayuno';
  };

  // Obtener icono del servicio
  const getServicioIcon = (servicio) => {
    const icons = {
      'Desayuno': '☕',
      'Almuerzo': '🍽️',
      'Cena': '🌙'
    };
    return icons[servicio] || '🍽️';
  };

  // Obtener color del servicio
  const getServicioColor = (servicio) => {
    const colors = {
      'Desayuno': '#faad14',
      'Almuerzo': '#52c41a',
      'Cena': '#722ed1'
    };
    return colors[servicio] || '#1890ff';
  };

  // Función para parsear el formato de la tarjeta
  const parsearTarjeta = (input) => {
    const limpio = input.replace(/[^\x20-\x7E;:=?◘]/g, '');
    
    // console.log('📟 Input original:', input);
    // console.log('📟 Input limpio:', limpio);
    
    const patron1 = /^;(\d+)/;
    const match1 = limpio.match(patron1);
    if (match1) {
      console.log('✅ Habitación encontrada (patrón 1):', match1[1]);
      return match1[1];
    }
    
    const patron2 = /;(\d+)/;
    const match2 = limpio.match(patron2);
    if (match2) {
      console.log('✅ Habitación encontrada (patrón 2):', match2[1]);
      return match2[1];
    }
    
    const patron3 = /^(\d+)/;
    const match3 = limpio.match(patron3);
    if (match3) {
      console.log('✅ Habitación encontrada (patrón 3):', match3[1]);
      return match3[1];
    }
    
    const soloNumeros = limpio.replace(/[^0-9]/g, '');
    if (soloNumeros.length > 0) {
      const posibleHabitacion = soloNumeros.match(/^\d{1,4}/)?.[0] || soloNumeros;
      console.log('⚠️ Habitación extraída de números:', posibleHabitacion);
      return posibleHabitacion;
    }
    
    console.log('❌ No se pudo extraer habitación');
    return input;
  };

  // Obtener estadísticas
  const fetchStats = async () => {
    
    
    if (!selectedService) return;
    

    try {
      const token = localStorage.getItem('token');
      
      const response = await axios.get(`${BASE_URL}/api/comedor`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          fecha: selectedDate.format('DD/MM/YYYY'),
          servicio: selectedService,
          //habitacion: hab,
          page: 1,
          pageSize: 100000
        }
      });
      
      // console.log(response.data.data);
      
      if (response.data.success) {
        const allData = response.data.data;
        const checkedInCount = allData.filter(item => item.checkedIn).length;
        const habitacionesCount = new Set(allData.map(d => d.Habitacion)).size;

        // console.log(" allData => ",allData.length);
        // console.log(" checkedInCount => ",checkedInCount);
        // console.log(" pending => ",allData.length - checkedInCount);
        
        
        setStats({
          total: allData.length,
          checkedIn: checkedInCount,
          pending: allData.length - checkedInCount,
          habitaciones: habitacionesCount
        });
      }
    } catch (error) {
      console.error('Error obteniendo estadísticas:', error);
    }
  };

  // Limpiar resultado y preparar para nueva búsqueda
  const limpiarResultado = () => {
    setResultado(null);
    setHabitacionInput('');
    setHabitacionActual('');
    setTimeout(() => inputRef.current?.focus(), 100);
  };

  // Manejar cambio en el input
  const handleInputChange = (e) => {
    const valor = e.target.value;
    
    if (valor.includes(';') || valor.includes('=') || valor.includes('?')) {
      const habitacion = parsearTarjeta(valor);
      setHabitacionInput(habitacion);
    } else {
      setHabitacionInput(valor);
    }
  };

  // Manejar cuando el input pierde el foco
  const handleInputBlur = (e) => {
    const valor = e.target.value;
    if (valor.includes(';') || valor.includes('=')) {
      const habitacion = parsearTarjeta(valor);
      setHabitacionInput(habitacion);
    }
  };

  // Verificar habitación
  const verificarHabitacion = async (habParam = null) => {
    let hab = habParam || habitacionInput.trim();
    
    if (hab.includes(';') || hab.includes('=') || hab.includes('?')) {
      hab = parsearTarjeta(hab);
    }
    
    if (!hab) {
      message.warning('Pase la tarjeta o ingrese el número de habitación');
      inputRef.current?.focus();
      return;
    }

    setLoading(true);
    setResultado(null);
    setHabitacionActual(hab);

    try {
      const token = localStorage.getItem('token');
      const response = await axios.get(`${BASE_URL}/api/comedor`, {
        headers: { Authorization: `Bearer ${token}` },
        params: {
          fecha: selectedDate.format('DD/MM/YYYY'),
          servicio: selectedService,
          habitacion: hab,
          page: 1,
          pageSize: 100
        }
      });

      if (response.data.success) {
        const huespedes = response.data.data;

        // console.log(" huespedes => ",huespedes);
        
        
        if (huespedes.length === 0) {
          setResultado({
            tieneServicio: false,
            mensaje: `Habitación ${hab} sin servicio de ${selectedService} el ${selectedDate.format('DD/MM/YYYY')}`,
            huespedes: []
          });
        } else {
          const tieneServicio = huespedes.length > 0;
          const todosRegistrados = huespedes.every(h => h.checkedIn);
          
          setResultado({
            tieneServicio,
            todosRegistrados,
            mensaje: `Habitación ${hab} - ${huespedes.length} ${huespedes.length === 1 ? 'huésped' : 'huéspedes'} con servicio`,
            huespedes: huespedes
          });
        }
      }
    } catch (error) {
      console.error('Error verificando habitación:', error);
      message.error('Error de conexión');
      setResultado({
        tieneServicio: false,
        mensaje: 'Error al verificar la habitación',
        huespedes: []
      });
    } finally {
      setLoading(false);
      setHabitacionInput('');
      fetchStats();
    }
  };

  // Registrar entrada de un huésped específico
  const registrarEntradaIndividual = async (huesped) => {
    if (huesped.checkedIn) {
      message.info(`${huesped.Nombre} ya está en el comedor`);
      return;
    }

    setLoadingCheckin(true);
    try {
      const token = localStorage.getItem('token');
      const response = await axios.post(
        `${BASE_URL}/api/comedor/checkin`,
        {
          numReserva: huesped.NumReserva,
          linea: huesped.Linea,
          numOcupante: huesped.NumOcupante,
          servicio: selectedService,
          fecha: selectedDate.format('DD/MM/YYYY'),
          checkIn: true
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      if (response.data.success) {
        message.success(`✅ ${huesped.Nombre} registrado en comedor`);
        
        if (resultado) {
          const huespedesActualizados = resultado.huespedes.map(h => 
            h.NumReserva === huesped.NumReserva && 
            h.Linea === huesped.Linea && 
            h.NumOcupante === huesped.NumOcupante
              ? { ...h, checkedIn: true }
              : h
          );
          const todosRegistrados = huespedesActualizados.every(h => h.checkedIn);
          setResultado({ 
            ...resultado, 
            huespedes: huespedesActualizados,
            todosRegistrados 
          });
        }
        
        fetchStats();
      }
    } catch (error) {
      message.error('Error al registrar entrada');
    } finally {
      setLoadingCheckin(false);
    }
  };

  // Añadir esta nueva función después de registrarEntradaIndividual

// Quitar registro de un huésped (deshacer check-in)
const quitarRegistroIndividual = async (huesped) => {
  if (!huesped.checkedIn) {
    message.info(`${huesped.Nombre} no está registrado en el comedor`);
    return;
  }

  setLoadingCheckin(true);
  try {
    const token = localStorage.getItem('token');
    const response = await axios.post(
      `${BASE_URL}/api/comedor/checkin`,
      {
        numReserva: huesped.NumReserva,
        linea: huesped.Linea,
        numOcupante: huesped.NumOcupante,
        servicio: selectedService,
        fecha: selectedDate.format('DD/MM/YYYY'),
        checkIn: false // false = quitar registro
      },
      { headers: { Authorization: `Bearer ${token}` } }
    );

    if (response.data.success) {
      message.success(`❌ Registro de ${huesped.Nombre} eliminado del comedor`);
      
      if (resultado) {
        const huespedesActualizados = resultado.huespedes.map(h => 
          h.NumReserva === huesped.NumReserva && 
          h.Linea === huesped.Linea && 
          h.NumOcupante === huesped.NumOcupante
            ? { ...h, checkedIn: false }
            : h
        );
        const todosRegistrados = huespedesActualizados.every(h => h.checkedIn);
        setResultado({ 
          ...resultado, 
          huespedes: huespedesActualizados,
          todosRegistrados 
        });
      }
      
      fetchStats();
    }
  } catch (error) {
    message.error('Error al quitar registro');
  } finally {
    setLoadingCheckin(false);
  }
};

// Quitar registro de TODOS los huéspedes de la habitación
const quitarTodosRegistros = async () => {
  if (!resultado?.huespedes?.length) return;
  
  const registrados = resultado.huespedes.filter(h => h.checkedIn);
  if (registrados.length === 0) {
    message.info('No hay huéspedes registrados en el comedor');
    return;
  }

  Modal.confirm({
    title: `¿Quitar todos los registros?`,
    content: `Se eliminará el registro de ${registrados.length} ${registrados.length === 1 ? 'huésped' : 'huéspedes'} de la habitación ${habitacionActual}`,
    okText: 'Sí, quitar todos',
    cancelText: 'Cancelar',
    okButtonProps: { danger: true },
    onOk: async () => {
      setLoadingCheckin(true);
      let successCount = 0;
      
      for (const huesped of registrados) {
        try {
          const token = localStorage.getItem('token');
          await axios.post(
            `${BASE_URL}/api/comedor/checkin`,
            {
              numReserva: huesped.NumReserva,
              linea: huesped.Linea,
              numOcupante: huesped.NumOcupante,
              servicio: selectedService,
              fecha: selectedDate.format('DD/MM/YYYY'),
              checkIn: false
            },
            { headers: { Authorization: `Bearer ${token}` } }
          );
          successCount++;
        } catch (error) {
          console.error('Error quitando registro:', error);
        }
      }
      
      setLoadingCheckin(false);
      
      if (successCount > 0) {
        message.success(`❌ Registro eliminado de ${successCount} ${successCount === 1 ? 'huésped' : 'huéspedes'}`);
        
        // Actualizar resultado local
        const huespedesActualizados = resultado.huespedes.map(h => ({ ...h, checkedIn: false }));
        setResultado({ 
          ...resultado, 
          huespedes: huespedesActualizados,
          todosRegistrados: false 
        });
        
        fetchStats();
      }
    }
  });
};

  // Acción de ENTRAR
  const accionEntrar = async () => {
    if (!resultado?.huespedes?.length) {
      limpiarResultado();
      return;
    }
    
    const pendientes = resultado.huespedes.filter(h => !h.checkedIn);
    
    if (pendientes.length === 0) {
      message.success(`✅ Habitación ${habitacionActual} - Todos ya estaban registrados`);
      limpiarResultado();
      return;
    }

    setLoadingCheckin(true);
    let successCount = 0;
    
    for (const huesped of pendientes) {
      try {
        const token = localStorage.getItem('token');
        await axios.post(
          `${BASE_URL}/api/comedor/checkin`,
          {
            numReserva: huesped.NumReserva,
            linea: huesped.Linea,
            numOcupante: huesped.NumOcupante,
            servicio: selectedService,
            fecha: selectedDate.format('DD/MM/YYYY'),
            checkIn: true
          },
          { headers: { Authorization: `Bearer ${token}` } }
        );
        successCount++;
      } catch (error) {
        console.error('Error registrando huésped:', error);
      }
    }
    
    setLoadingCheckin(false);
    
    if (successCount > 0) {
      message.success(`✅ ${successCount} ${successCount === 1 ? 'huésped registrado' : 'huéspedes registrados'} - ¡Que aproveche!`);
    }
    
    fetchStats();
    limpiarResultado();
  };

  // Acción de CANCELAR
  const accionCancelar = () => {
    message.info(`Habitación ${habitacionActual} - Acceso cancelado`);
    limpiarResultado();
  };

  // Cambiar fecha
  const handleDateChange = (date) => {
    if (date) {
      setSelectedDate(date);
    }
  };

  // Cambiar servicio
  const handleServiceChange = (service) => {
    setSelectedService(service);
  };

  // Inicialización
  useEffect(() => {
    const servicioPorHora = getServicioByHora();
    setSelectedService(servicioPorHora);
  }, []);

  // Cargar estadísticas cuando cambie fecha o servicio
  useEffect(() => {
    if (selectedService) {
      fetchStats();
      limpiarResultado();
    }
  }, [selectedDate, selectedService]);

  // Enfocar input al cargar
  useEffect(() => {
    inputRef.current?.focus();
    
    const handleKeyDown = (e) => {
      if (e.key === 'Enter' && habitacionInput.trim()) {
        verificarHabitacion();
      }
    };
    
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [habitacionInput, selectedDate, selectedService]);

  // Teclas de acción cuando hay resultado
  useEffect(() => {
    const handleActionKeys = (e) => {
      if (!resultado) return;
      
      if (e.key === 'e' || e.key === 'E' || e.key === '1') {
        e.preventDefault();
        accionEntrar();
      }
      
      if (e.key === 'c' || e.key === 'C' || e.key === 'Escape') {
        e.preventDefault();
        accionCancelar();
      }
    };
    
    document.addEventListener('keydown', handleActionKeys);
    return () => document.removeEventListener('keydown', handleActionKeys);
  }, [resultado, habitacionActual, selectedDate, selectedService]);

  // Renderizar panel de filtros (Fecha y Servicio)
  const renderFiltros = () => {
    if (!filtrosExpandidos) return null;
    
    return (
      <>
        <Divider style={{ margin: '16px 0' }} />
        <Row gutter={[16, 16]}>
          <Col xs={24} sm={12}>
            <Space direction="vertical" style={{ width: '100%' }}>
              <Text strong>📅 Fecha</Text>
              <DatePicker
                value={selectedDate}
                onChange={handleDateChange}
                format="DD/MM/YYYY"
                style={{ width: '100%', borderRadius: 20, height: 48 }}
                suffixIcon={<CalendarOutlined />}
                size="large"
                allowClear={false}
              />
            </Space>
          </Col>
          <Col xs={24} sm={12}>
            <Space direction="vertical" style={{ width: '100%' }}>
              <Text strong>🍽️ Servicio</Text>
              <Select
                value={selectedService}
                onChange={handleServiceChange}
                style={{ width: '100%', borderRadius: 20 }}
                size="large"
                options={[
                  { 
                    value: 'Desayuno', 
                    label: (
                      <span>
                        <span style={{ marginRight: 8 }}>☕</span>
                        Desayuno (01:00 - 11:00)
                      </span>
                    )
                  },
                  { 
                    value: 'Almuerzo', 
                    label: (
                      <span>
                        <span style={{ marginRight: 8 }}>🍽️</span>
                        Almuerzo (12:00 - 16:00)
                      </span>
                    )
                  },
                  { 
                    value: 'Cena', 
                    label: (
                      <span>
                        <span style={{ marginRight: 8 }}>🌙</span>
                        Cena (18:00 - 23:00)
                      </span>
                    )
                  },
                ]}
              />
            </Space>
          </Col>
        </Row>
      </>
    );
  };

  // Renderizar resultado
  const renderResultado = () => {
    if (loading) {
      return (
        <div style={{ textAlign: 'center', padding: 40 }}>
          <Spin size="large" />
          <Text style={{ display: 'block', marginTop: 16, fontSize: 18 }}>Verificando habitación...</Text>
        </div>
      );
    }

    if (!resultado) {
      return (
        <div style={{ textAlign: 'center', padding: 60 }}>
          <CoffeeOutlined style={{ fontSize: 80, color: '#d9d9d9' }} />
          <Text type="secondary" style={{ display: 'block', marginTop: 16, fontSize: 20 }}>
            Pase la tarjeta o ingrese el número de habitación
          </Text>
          <Text type="secondary" style={{ display: 'block', marginTop: 8, fontSize: 14 }}>
            {isAndroid ? 'Use el teclado numérico' : 'El lector enviará el número automáticamente'}
          </Text>
        </div>
      );
    }

    const { tieneServicio, mensaje, huespedes, todosRegistrados } = resultado;
    const pendientes = huespedes.filter(h => !h.checkedIn).length;
    const registrados = huespedes.filter(h => h.checkedIn).length;

// En la función renderResultado, dentro de la parte de ACCESO PERMITIDO

if (tieneServicio) {
  // Si todos ya están registrados
  if (todosRegistrados) {
    return (
      <div>
        <Alert
          message={
            <Text strong style={{ fontSize: 28, color: '#fa8c16' }}>
              ⚠️ YA REGISTRADOS
            </Text>
          }
          description={
            <Text style={{ fontSize: 18 }}>
              Habitación {habitacionActual} - Todos los huéspedes ya están en el comedor
            </Text>
          }
          type="warning"
          showIcon={false}
          style={{ marginBottom: 24, borderRadius: 16, textAlign: 'center' }}
        />

        <Card 
          size="small" 
          style={{ 
            marginBottom: 24, 
            borderRadius: 16, 
            background: '#fff7e6',
            border: '1px solid #ffd591'
          }}
        >
          <Row gutter={16} justify="center">
            <Col>
              <Statistic
                title="Total huéspedes"
                value={huespedes.length}
                prefix={<TeamOutlined />}
                valueStyle={{ color: '#1890ff', fontSize: 24 }}
              />
            </Col>
            <Col>
              <Statistic
                title="En comedor"
                value={registrados}
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: '#52c41a', fontSize: 24 }}
              />
            </Col>
            <Col>
              <Statistic
                title="Pendientes"
                value={0}
                prefix={<CheckCircleOutlined />}
                valueStyle={{ color: '#52c41a', fontSize: 24 }}
              />
            </Col>
          </Row>
        </Card>

        <div style={{ marginBottom: 24 }}>
          <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 12 }}>
            Huéspedes en habitación {habitacionActual}:
          </Text>
          
          {huespedes.map((huesped, index) => (
            <Card
              key={index}
              size="small"
              style={{
                marginBottom: 8,
                borderRadius: 12,
                background: '#f6ffed',
                border: '1px solid #b7eb8f'
              }}
              bodyStyle={{ padding: '12px 16px' }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div style={{ flex: 1 }}>
                  <Text strong style={{ fontSize: 16 }}>
                    {huesped.Nombre}
                  </Text>
                  <div style={{ marginTop: 4 }}>
                    <Tag color="success" icon={<CheckCircleOutlined />}>
                      En comedor
                    </Tag>
                    {huesped.TodoIncluido === 'X' && (
                      <Tag color="gold">Todo Incluido</Tag>
                    )}
                    {huesped.BebidaIncluida === 'Si' && (
                      <Tag color="blue" style={{ fontWeight: 'bold' }}>🍷 Bebida Incluida</Tag>
                    )}
                    <Text type="secondary" style={{ fontSize: 13 }}>
                      {huesped.Regimen}
                    </Text>
                  </div>
                </div>
                
                <Tag color="success" style={{ fontSize: 14, padding: '4px 12px' }}>
                  <CheckCircleOutlined /> OK
                </Tag>
              </div>
            </Card>
          ))}
        </div>

      <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
        <Button
          type="default"
          size="large"
          danger
          icon={<CloseCircleOutlined />}
          onClick={quitarTodosRegistros}
          loading={loadingCheckin}
          style={{ 
            flex: 1, 
            height: 80, 
            borderRadius: 40, 
            fontSize: 20, 
            fontWeight: 'bold'
          }}
        >
          QUITAR TODOS
        </Button>
        
        <Button
          type="primary"
          size="large"
          onClick={accionCancelar}
          style={{ 
            flex: 1, 
            height: 80, 
            borderRadius: 40, 
            fontSize: 24, 
            fontWeight: 'bold'
          }}
        >
          VOLVER
        </Button>
      </div>
        
        <div style={{ textAlign: 'center', marginTop: 16 }}>
          <Text type="secondary">
            Tecla rápida: <Tag>ESC</Tag> o <Tag>C</Tag> para continuar
          </Text>
        </div>
      </div>
    );
  }

  // Si hay pendientes (resultado normal con botones ENTRAR/CANCELAR)
  return (
    <div>
      <Alert
        message={
          <Text strong style={{ fontSize: 28, color: '#52c41a' }}>
            ✅ ACCESO PERMITIDO
          </Text>
        }
        description={
          <Text style={{ fontSize: 18 }}>
            {mensaje}
          </Text>
        }
        type="success"
        showIcon={false}
        style={{ marginBottom: 24, borderRadius: 16, textAlign: 'center' }}
      />

      <Card 
        size="small" 
        style={{ 
          marginBottom: 24, 
          borderRadius: 16, 
          background: '#f6ffed',
          border: '1px solid #b7eb8f'
        }}
      >
        <Row gutter={16} justify="center">
          <Col>
            <Statistic
              title="Total huéspedes"
              value={huespedes.length}
              prefix={<TeamOutlined />}
              valueStyle={{ color: '#1890ff', fontSize: 24 }}
            />
          </Col>
          <Col>
            <Statistic
              title="Ya en comedor"
              value={registrados}
              prefix={<CheckCircleOutlined />}
              valueStyle={{ color: '#52c41a', fontSize: 24 }}
            />
          </Col>
          <Col>
            <Statistic
              title="Pendientes"
              value={pendientes}
              prefix={<ClockCircleOutlined />}
              valueStyle={{ color: '#fa8c16', fontSize: 24 }}
            />
          </Col>
        </Row>
      </Card>

      <div style={{ marginBottom: 24 }}>
        <Text strong style={{ fontSize: 16, display: 'block', marginBottom: 12 }}>
          Huéspedes en habitación {habitacionActual}:
        </Text>
        
        {huespedes.map((huesped, index) => (
          <Card
            key={index}
            size="small"
            style={{
              marginBottom: 8,
              borderRadius: 12,
              background: huesped.checkedIn ? '#f6ffed' : '#fff',
              border: huesped.checkedIn ? '1px solid #b7eb8f' : '1px solid #f0f0f0'
            }}
            bodyStyle={{ padding: '12px 16px' }}
          >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div style={{ flex: 1 }}>
                <Text strong style={{ fontSize: 16 }}>
                  {huesped.Nombre}
                </Text>
                <div style={{ marginTop: 4 }}>
                  <Tag color={huesped.checkedIn ? 'success' : 'default'} icon={huesped.checkedIn ? <CheckCircleOutlined /> : <ClockCircleOutlined />}>
                    {huesped.checkedIn ? 'En comedor' : 'Pendiente'}
                  </Tag>
                  {huesped.TodoIncluido === 'X' && (
                    <Tag color="gold">Todo Incluido</Tag>
                  )}
                  {huesped.BebidaIncluida === 'Si' && (
                    <Tag color="blue" style={{ fontWeight: 'bold' }}>🍷 Bebida Incluida</Tag>
                  )}
                  <Text type="secondary" style={{ fontSize: 13 }}>
                    {huesped.Regimen}
                  </Text>
                </div>
              </div>
              
              {!huesped.checkedIn && (
                <Button
                  type="link"
                  icon={<LoginOutlined />}
                  onClick={() => registrarEntradaIndividual(huesped)}
                  loading={loadingCheckin}
                  style={{ color: '#52c41a' }}
                >
                  Registrar
                </Button>
              )}
              
              {huesped.checkedIn && (
                <Tag color="success" style={{ fontSize: 14, padding: '4px 12px' }}>
                  <CheckCircleOutlined /> OK
                </Tag>
              )}
            </div>
          </Card>
        ))}
      </div>

      <div style={{ display: 'flex', gap: 16, justifyContent: 'center' }}>
        <Button
          type="primary"
          size="large"
          icon={<LoginOutlined />}
          onClick={accionEntrar}
          loading={loadingCheckin}
          style={{ 
            flex: 1, 
            height: 80, 
            borderRadius: 40, 
            fontSize: 24, 
            fontWeight: 'bold',
            background: '#52c41a',
            borderColor: '#52c41a'
          }}
        >
          ENTRAR ({pendientes > 0 ? pendientes : 'OK'})
        </Button>
        
        <Button
          type="default"
          size="large"
          danger
          icon={<CloseOutlined />}
          onClick={accionCancelar}
          style={{ 
            flex: 1, 
            height: 80, 
            borderRadius: 40, 
            fontSize: 24, 
            fontWeight: 'bold'
          }}
        >
          CANCELAR
        </Button>
      </div>
      
      <div style={{ textAlign: 'center', marginTop: 16 }}>
        <Text type="secondary">
          Teclas rápidas: <Tag>E</Tag> para Entrar · <Tag>ESC</Tag> o <Tag>C</Tag> para Cancelar
        </Text>
      </div>
    </div>
  );
}

    return (
      <div style={{ textAlign: 'center' }}>
        <Alert
          message={
            <Text strong style={{ fontSize: 28, color: '#ff4d4f' }}>
              ❌ ACCESO DENEGADO
            </Text>
          }
          description={
            <Text style={{ fontSize: 18 }}>
              {mensaje}
            </Text>
          }
          type="error"
          showIcon={false}
          style={{ marginBottom: 32, borderRadius: 16 }}
        />
        
        <Button
          type="primary"
          size="large"
          onClick={accionCancelar}
          style={{ 
            height: 80, 
            borderRadius: 40, 
            fontSize: 24, 
            fontWeight: 'bold',
            padding: '0 48px'
          }}
        >
          ENTENDIDO
        </Button>
        
        <div style={{ textAlign: 'center', marginTop: 24 }}>
          <Text type="secondary">
            Tecla rápida: <Tag>ESC</Tag> o <Tag>C</Tag> para continuar
          </Text>
        </div>
      </div>
    );
  };

  return (
    <ConfigProvider
      theme={{
        components: {
          Card: { borderRadiusLG: 20 },
          Button: { borderRadius: 20 },
          Input: { borderRadius: 24 },
        }
      }}
    >
      <div style={{ 
        minHeight: '100vh', 
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        padding: 20
      }}>
        <div style={{ maxWidth: 900, margin: '0 auto' }}>
          {/* Header */}
          <Card style={{ marginBottom: 16, borderRadius: 20, background: 'rgba(255,255,255,0.95)' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
              <div>
                <Title level={2} style={{ margin: 0, color: '#667eea' }}>
                  <CoffeeOutlined /> Control de Comedor
                </Title>
                <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginTop: 4 }}>
                  <Tag 
                    color={getServicioColor(selectedService)} 
                    style={{ fontSize: 14, padding: '4px 12px', borderRadius: 16 }}
                  >
                    {getServicioIcon(selectedService)} {selectedService}
                  </Tag>
                  <Tag icon={<CalendarOutlined />} style={{ fontSize: 14, padding: '4px 12px', borderRadius: 16 }}>
                    {selectedDate.format('DD/MM/YYYY')}
                  </Tag>
                </div>
              </div>
              <Space>
                <Button 
                  icon={filtrosExpandidos ? <UpOutlined /> : <DownOutlined />}
                  onClick={() => setFiltrosExpandidos(!filtrosExpandidos)}
                  size="large"
                  style={{ borderRadius: 20 }}
                >
                  {filtrosExpandidos ? 'Ocultar' : 'Cambiar fecha/servicio'}
                </Button>
                <Button 
                  icon={<ReloadOutlined />} 
                  onClick={() => {
                    fetchStats();
                    message.success('Estadísticas actualizadas');
                  }}
                  size="large"
                  style={{ borderRadius: 20 }}
                />
              </Space>
            </div>
            
            {/* Panel de filtros expandible */}
            {renderFiltros()}
          </Card>

          {/* Estadísticas */}
          <Card style={{ marginBottom: 16, borderRadius: 20, background: 'rgba(255,255,255,0.95)' }}>
            <Row gutter={[16, 16]}>
              <Col span={6}>
                <Statistic
                  title="Total"
                  value={stats.total}
                  prefix={<TeamOutlined />}
                  valueStyle={{ color: '#1890ff' }}
                />
              </Col>
              <Col span={6}>
                <Statistic
                  title="En comedor"
                  value={stats.checkedIn}
                  prefix={<CheckCircleOutlined />}
                  valueStyle={{ color: '#52c41a' }}
                />
              </Col>
              <Col span={6}>
                <Statistic
                  title="Pendientes"
                  value={stats.pending}
                  prefix={<ClockCircleOutlined />}
                  valueStyle={{ color: '#fa8c16' }}
                />
              </Col>
              <Col span={6}>
                <Statistic
                  title="Habitaciones"
                  value={stats.habitaciones}
                  prefix={<TeamOutlined />}
                  valueStyle={{ color: '#722ed1' }}
                />
              </Col>
            </Row>
            <Progress
              percent={stats.total ? (stats.checkedIn / stats.total * 100) : 0}
              showInfo={false}
              strokeColor="#52c41a"
              trailColor="#f0f0f0"
              style={{ marginTop: 12 }}
            />
          </Card>

          {/* Input de habitación */}
          {!resultado && (
            <Card style={{ marginBottom: 16, borderRadius: 20, background: 'rgba(255,255,255,0.95)' }}>
              <Space.Compact style={{ width: '100%' }}>
                <Input
                  ref={inputRef}
                  placeholder="Pase la tarjeta o ingrese habitación..."
                  value={habitacionInput}
                  onChange={handleInputChange}
                  onBlur={handleInputBlur}
                  onPressEnter={() => verificarHabitacion()}
                  size="large"
                  style={{ 
                    fontSize: 22, 
                    height: 72,
                    textAlign: 'center',
                    borderRadius: 36
                  }}
                  prefix={<SearchOutlined style={{ fontSize: 28, color: '#999' }} />}
                  allowClear
                  autoFocus
                  inputMode={isAndroid ? "numeric" : "text"}
                  type={isAndroid ? "tel" : "text"}
                  pattern={isAndroid ? "[0-9]*" : undefined}
                />
              </Space.Compact>
              <Button
                type="primary"
                size="large"
                block
                onClick={() => verificarHabitacion()}
                loading={loading}
                style={{ marginTop: 12, height: 56, borderRadius: 28, fontSize: 18 }}
              >
                Verificar Habitación
              </Button>
              
              {/* Botón de prueba para simular lector */}
              {process.env.NODE_ENV === 'development' && (
                <Button
                  size="small"
                  onClick={() => {
                    const testTarjeta = ';101:::::=0300000=2201225::::::::::?';
                    const hab = parsearTarjeta(testTarjeta);
                    setHabitacionInput(hab);
                    setTimeout(() => verificarHabitacion(hab), 100);
                  }}
                  style={{ marginTop: 8 }}
                >
                  Probar con tarjeta 101
                </Button>
              )}
            </Card>
          )}

          {/* Resultado */}
          <Card style={{ borderRadius: 20, background: 'rgba(255,255,255,0.95)', minHeight: 400 }}>
            {renderResultado()}
          </Card>
        </div>
      </div>
    </ConfigProvider>
  );
};

export default MetreEntrada;